var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconReports(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 44,
    viewBox: "0 0 36 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 18,
    cy: 43,
    fill: "#333852",
    fillOpacity: 0.1,
    rx: 18,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333852",
    fillRule: "nonzero",
    d: "M8 8.002v2H5a3 3 0 0 0-3 3V31a3 3 0 0 0 3 3h13.999a3 3 0 0 0 3-3v-3h2v3a5 5 0 0 1-5 5h-14A5 5 0 0 1 0 31V13.001a5 5 0 0 1 5-5h3zm15.999-6h-11a3 3 0 0 0-3 3V23a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V8h-5a1 1 0 0 1-1-1v-5zm8 5.056V23a5 5 0 0 1-5 5h-14a5 5 0 0 1-5-5V5a5 5 0 0 1 5-4.999h11.944a.978.978 0 0 1 .763.293l6 6c.22.22.31.497.292.763zm-6-1.056h2.585L26 3.416v2.586z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#856DCB",
    fillRule: "nonzero",
    d: "M15 20a1 1 0 0 1 0-1.999h3.999a1 1 0 1 1 0 2h-4zM15 16.001a1 1 0 1 1 0-2h9.999a1 1 0 1 1 0 2h-10zM15 12.001a1 1 0 1 1 0-2h9.999a1 1 0 1 1 0 2h-10z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReports);
export default __webpack_public_path__ + "static/media/icon-reports.39f83c0a78acbb1d0348acf2d90cac83.svg";
export { ForwardRef as ReactComponent };